// src/pages/Envios.jsx
import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { getRates } from '../services/rates';
import { useNavigate } from 'react-router-dom';
import { db } from '../firebase';
import { useAuth } from '../context/AuthContext';
import { collection, addDoc } from 'firebase/firestore';

// API key para imgbb (colócala en .env como REACT_APP_IMGBB_KEY)
const IMGBB_KEY = process.env.REACT_APP_IMGBB_KEY;

// Función para obtener la abreviatura de la divisa
const getCurrencyAbbreviation = (currency) => {
  const mapping = {
    USD: 'USD',
    EUR: 'EUR',
    Bs: 'Bs',
    COP: 'COP'
  };
  return mapping[currency] || currency;
};

// Función para retornar los métodos de pago de origen según la moneda
const getPaymentMethodsForOrigen = (origen) => {
  if (origen === "USD") return ["Banesco Panama", "Zelle", "Paypal", "Efectivo"];
  // if (origen === "EUR") return ["Efectivo"];
  if (origen === "Bs") return ["Transferencia Bancaria", "Pago Móvil", "Efectivo"];
  // if (origen === "COP") return ["Efectivo"];
  return ["Transferencia Bancaria"];
};

// Función para retornar los métodos de pago de destino según la moneda
const getPaymentMethodsForDestino = (destino) => {
  if (destino === "USD") return ["Efectivo", "Paypal", "Zelle"];
  // if (destino === "EUR") return ["Efectivo"];
  if (destino === "Bs") return ["Transferencia Bancaria", "Pago Móvil", "Efectivo"];
  // if (destino === "COP") return ["Efectivo"];
  return ["Transferencia Bancaria"];
};

const Envios = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  // Estados para el formulario interactivo
  const [origen, setOrigen] = useState('USD');
  const [destino, setDestino] = useState('USD');
  const [metodo, setMetodo] = useState('Zelle');
  const [destinoMetodo, setDestinoMetodo] = useState('Efectivo');
  const [sendAmount, setSendAmount] = useState(0);
  const [receiveAmount, setReceiveAmount] = useState(0);
  const [mensaje, setMensaje] = useState("Ingrese el monto a enviar o el monto a recibir para ver el detalle de la transacción.");

  // Estados para tasas obtenidas de getRates
  const [rates, setRates] = useState({
    vesRate: null,
    vesUsdRate: null,
    usdCopRate: null,
    copUsdRate: null
  });

  // Estado para determinar cuál campo se modificó por última vez ("send" o "receive")
  const [lastModified, setLastModified] = useState("send");

  // Estado para mostrar el modal de datos del pago
  const [showModal, setShowModal] = useState(false);

  // Estados para datos del pago en el modal
  const [paymentReceipt, setPaymentReceipt] = useState(null);
  // Datos del titular que envía
  const [senderFirstName, setSenderFirstName] = useState('');
  const [senderLastName1, setSenderLastName1] = useState('');
  const [senderFullName, setSenderFullName] = useState('');
  // Datos de la cuenta que recibe
  const [receiverID, setReceiverID] = useState('');
  const [receiverAccountNumber, setReceiverAccountNumber] = useState('');
  const [receiverMobile, setReceiverMobile] = useState('');
  const [receiverEmail, setReceiverEmail] = useState('');
  const [receiverFirstName, setReceiverFirstName] = useState('');
  const [receiverLastName, setReceiverLastName] = useState('');
  const [receiverBank, setReceiverBank] = useState('');
  
  // Mensaje de notificación
  const [notificationMessage, setNotificationMessage] = useState('');


  useEffect(() => {
    AOS.init({ duration: 1000 });
    // Obtener tasas en tiempo real
    const fetchRates = async () => {
      try {
        const data = await getRates();
        setRates({
          vesRate: data.vesRate || null,
          vesUsdRate: data.vesUsdRate || null,
          usdCopRate: data.usdCopRate || null,
          copUsdRate: data.copUsdRate || null,
        });
      } catch (error) {
        console.error("Error obteniendo tasas:", error);
      }
    };
    fetchRates();
  }, []);

  // Actualizar método de pago de origen si cambia la moneda
  useEffect(() => {
    const methods = getPaymentMethodsForOrigen(origen);
    if (!methods.includes(metodo)) {
      setMetodo(methods[0]);
    }
  }, [origen, metodo]);

  // Actualizar método de pago destino al cambiar la divisa de destino
  useEffect(() => {
    // Excluir el método de origen de los métodos de destino
    const methods = getPaymentMethodsForDestino(destino).filter((m) => m !== metodo);
    if (!methods.includes(destinoMetodo)) {
      setDestinoMetodo(methods[0]);
    }
  }, [destino, metodo, destinoMetodo]);

  // Calcular tasa efectiva usando las tasas y descuentos
  const conversionRates = {
    "USD->USD": 1,
    "USD->EUR": 0,
    "USD->Bs": rates.vesRate !== null ? rates.vesRate : 0,
    "Bs->USD": rates.vesUsdRate !== null ? rates.vesUsdRate : (1 / 0),
    "USD->COP": rates.usdCopRate !== null ? rates.usdCopRate : 0,
    "COP->USD": rates.copUsdRate !== null ? rates.copUsdRate : (1 / 0),
    "EUR->USD": 1 / 0,
  };
  const key = `${origen}->${destino}`;
  let tasa = conversionRates[key] !== undefined ? conversionRates[key] : 1;

  const descuentos = {
    "Banesco Panama": { "Transferencia": 10, "Pago Móvil": 10, "Efectivo": 5 },
    "Zelle": { "Transferencia": 10, "Pago Móvil": 10, "Efectivo": 5 },
    "Paypal": { "Transferencia": 12, "Pago Móvil": 12, "Efectivo": 12 },
  };
  let descuento = descuentos[metodo]?.[destinoMetodo] || 0;
  const effectiveRate = tasa * (1 - descuento / 100);

  // Actualizar el mensaje y la conversión en función del campo modificado
  useEffect(() => {
    if (effectiveRate === 0) return;
    if (lastModified === "send") {
      const newReceive = parseFloat((sendAmount * effectiveRate).toFixed(2));
      if (Math.abs(newReceive - receiveAmount) > 0.01) {
        setReceiveAmount(newReceive);
      }
      const sendFormatted = parseFloat(sendAmount).toFixed(2);
      const receiveFormatted = newReceive.toFixed(2);
      setMensaje(
        `Envia: ${sendFormatted} ${origen} → Recibe: ${receiveFormatted} ${destino}`
      );
    } else if (lastModified === "receive") {
      const newSend = effectiveRate === 0 ? 0 : parseFloat((receiveAmount / effectiveRate).toFixed(2));
      if (Math.abs(newSend - sendAmount) > 0.01) {
        setSendAmount(newSend);
      }
      const sendFormatted = newSend.toFixed(2);
      const receiveFormatted = parseFloat(receiveAmount).toFixed(2);
      setMensaje(
        `Envia: ${sendFormatted} ${origen} → Recibe: ${receiveFormatted} ${destino}`
      );
    }
  }, [sendAmount, receiveAmount, effectiveRate, lastModified, origen, destino]);

  // Handler para el input "Monto a Enviar"
  const handleSendChange = (e) => {
    const value = e.target.value.replace(/^0+/, '') || '0';
    const amount = parseFloat(value);
    if (!isNaN(amount)) {
      setLastModified("send");
      setSendAmount(amount);
    }
  };

  // Handler para el input "Monto a Recibir"
  const handleReceiveChange = (e) => {
    const value = e.target.value.replace(/^0+/, '') || '0';
    const amount = parseFloat(value);
    if (!isNaN(amount)) {
      setLastModified("receive");
      setReceiveAmount(amount);
    }
  };

  // Handler para el submit del formulario interactivo
  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (user) {
      setShowModal(true);
    } else {
      navigate('/login', { state: { sendAmount, receiveAmount, origen, destino } });
    }
  };

  // Handler para cambios en el comprobante (solo imágenes)
  const handleReceiptChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      
      // Verificar si el archivo es una imagen y si su tamaño es menor a 1MB
      if (!file.type.startsWith('image/')) {
        alert('Solo se permiten imágenes para el comprobante.');
        return;
      }
  
      if (file.size > 1048576) { // 1MB = 1048576 bytes
        alert('El tamaño del archivo no puede ser mayor a 1 MB.');
        return;
      }
      
      // Si el archivo es válido, actualizar el estado
      setPaymentReceipt(file);
    }
  };
  

  // Handler para el submit del modal de pago: enviar datos a Firestore vinculados al usuario autenticado
  const handleModalSubmit = async (e) => {
    e.preventDefault();
    try {
      // build sender data depending on origin payment method
      let senderData = {};
      if (metodo === 'Banesco Panama') {
        senderData = { fullName: senderFullName };
      } else if (metodo === 'Zelle' || metodo === 'Paypal') {
        senderData = { firstName: senderFirstName, lastName: senderLastName1 };
      }
      // build receiver data based on destination payment method
      let receiverData = {};
      if (destinoMetodo === 'Zelle' || destinoMetodo === 'Paypal') {
        receiverData = { firstName: receiverFirstName, lastName: receiverLastName, email: receiverEmail };
      } else if (destinoMetodo === 'Transferencia Bancaria') {
        receiverData = { firstName: receiverFirstName, lastName: receiverLastName, accountNumber: receiverAccountNumber };
      } else if (destinoMetodo === 'Pago Móvil') {
        receiverData = { firstName: receiverFirstName, lastName: receiverLastName, mobile: receiverMobile, bank: receiverBank, id: receiverID };
      }
      else if (destinoMetodo === 'Efectivo') {
        receiverData = { firstName: receiverFirstName, lastName: receiverLastName, id: receiverID, mobile: receiverMobile };
      }
      // Subir comprobante a imgbb y obtener la URL
      let receiptPath = null;
      if (paymentReceipt && IMGBB_KEY) {
        const formData = new FormData();
        formData.append('image', paymentReceipt);
        const res = await fetch(`https://api.imgbb.com/1/upload?key=${IMGBB_KEY}`, {
          method: 'POST',
          body: formData
        });
        const { data } = await res.json();
        receiptPath = data?.url || null;
      }
      const paymentData = {
        paymentReceipt: receiptPath,
        sender: senderData,
        receiver: receiverData,
        status: 'En revisión',
        sendAmount,
        receiveAmount,
        origen,
        destino,
        createdAt: new Date().toISOString(),
        userId: user.uid
      };
      // Obtener el ID del usuario autenticado y agregarlo a los datos del pago
      const userId = user.uid;
      const paymentDataWithUser = { ...paymentData, userId };

      // Agregar el documento a la colección "payments"
      await addDoc(collection(db, "payments"), paymentDataWithUser);
      setNotificationMessage("Tu operación está en revisión. Te notificaremos por correo electrónico cuando sea aprobada.");
      // Limpiar todos los campos de formulario al finalizar el envío
      setShowModal(false);
      setOrigen('USD');
      setDestino('USD');
      setMetodo('Zelle');
      setDestinoMetodo('Efectivo');
      setSendAmount(0);
      setReceiveAmount(0);
      setMensaje("Ingrese el monto a enviar o el monto a recibir para ver el detalle de la transacción.");
      setPaymentReceipt(null);
      setSenderFirstName('');
      setSenderLastName1('');
      setSenderFullName('');
      setReceiverID('');
      setReceiverAccountNumber('');
      setReceiverMobile('');
      setReceiverEmail('');
      setReceiverFirstName('');
      setReceiverLastName('');
      setReceiverBank('');
      console.log("Datos del pago enviados a Firestore:", paymentDataWithUser);
      // Aquí puedes agregar una notificación de éxito o redirigir según necesites
    } catch (error) {
      console.error("Error al procesar el comprobante:", error);
      setNotificationMessage("Hubo un error al procesar la transacción.");
    }
  };

  return (
    <>
      <Header />
      <section className="hero-section" id="hero-envios">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-8" data-aos="fade-right">
              <h1>Realiza tu Envío de Divisas</h1>
              <p className="mb-4">
                Envía dinero de la divisa que elijas, selecciona los métodos de pago de origen y destino, y conoce cuánto recibirás.
              </p>
            </div>
            <div className="col-lg-4" data-aos="fade-left">
              <img src="/assets/img/transfer.png" alt="Envío de dinero" className="img-fluid" />
            </div>
          </div>
        </div>
      </section>
      <main id="main">
        <section className="section">
          <div className="container">
            <h2 className="mb-4">Transacción Interactiva</h2>
            <form className="php-email-form" onSubmit={handleFormSubmit}>
              <div className="row">
                <div className="col-md-6 form-group">
                  <label htmlFor="origen">Divisa de Origen</label>
                  <select
                    id="origen"
                    className="form-control"
                    value={origen}
                    onChange={(e) => setOrigen(e.target.value)}
                  >
                    <option value="USD">USD</option>
                    {/* <option value="EUR">Euros</option> */}
                    <option value="Bs">Bolívares</option>
                    {/* <option value="COP">COP</option> */}
                  </select>
                </div>
                <div className="col-md-6 form-group">
                  <label htmlFor="destino">Divisa de Destino</label>
                  <select
                    id="destino"
                    className="form-control"
                    value={destino}
                    onChange={(e) => setDestino(e.target.value)}
                  >
                    <option value="USD">USD</option>
                    {/* <option value="EUR">Euros</option> */}
                    <option value="Bs">Bolívares</option>
                    {/* <option value="COP">COP</option> */}
                  </select>
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-md-6 form-group">
                  <label htmlFor="metodo">Método de Pago Origen</label>
                  <select
                    id="metodo"
                    className="form-control"
                    value={metodo}
                    onChange={(e) => setMetodo(e.target.value)}
                  >
                    {getPaymentMethodsForOrigen(origen).map((opcion) => (
                      <option key={opcion} value={opcion}>
                        {opcion}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-6 form-group">
                  <label htmlFor="destinoMetodo">Método de Pago Destino</label>
                  <select
                    id="destinoMetodo"
                    className="form-control"
                    value={destinoMetodo}
                    onChange={(e) => setDestinoMetodo(e.target.value)}
                  >
                    {getPaymentMethodsForDestino(destino)
                      .filter((opcion) => opcion !== metodo)
                      .map((opcion) => (
                        <option key={opcion} value={opcion}>
                          {opcion}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="row mt-3">
                {/* Input para Monto a Enviar */}
                <div className="col-md-6 form-group">
                  <label htmlFor="monto">Monto a Enviar</label>
                  <div className="input-group">
                    <input
                      type="number"
                      id="monto"
                      className="form-control"
                      placeholder="Ingrese el monto a enviar"
                      value={sendAmount || ''}
                      onChange={handleSendChange}
                      required
                    />
                    <span className="input-group-text">{getCurrencyAbbreviation(origen)}</span>
                  </div>
                </div>
                {/* Input para Monto a Recibir */}
                <div className="col-md-6 form-group">
                  <label htmlFor="montoRecibir">Monto a Recibir</label>
                  <div className="input-group">
                    <input
                      type="number"
                      id="montoRecibir"
                      className="form-control"
                      placeholder={`Ingrese el monto a recibir en ${getCurrencyAbbreviation(destino)}`}
                      value={receiveAmount || ''}
                      onChange={handleReceiveChange}
                      required
                    />
                    <span className="input-group-text">{getCurrencyAbbreviation(destino)}</span>
                  </div>
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-md-12">
                  <div id="mensaje-interactivo" className="alert alert-info" role="alert">
                    {mensaje}
                  </div>
                </div>
              </div>
              <div className="form-group mt-3">
                <button type="submit" className="btn btn-primary">
                  Enviar Dinero
                </button>
              </div>
            </form>
          </div>
        </section>
      </main>
      {notificationMessage && (
        <div className="alert alert-info" role="alert">
          {notificationMessage}
        </div>
      )}
      <Footer />

      {/* Modal de Bootstrap para datos del pago */}
      {showModal && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          role="dialog"
          aria-modal="true"
          style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
        >
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Detalles del Pago</h5>
                <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
              </div>
              <form onSubmit={handleModalSubmit}>
                <div className="modal-body p-4">
                  {/* Comprobante del pago solo para Banesco Panama y Transferencia Bancaria */}
                  {(metodo === 'Banesco Panama' || metodo === 'Transferencia Bancaria') && (
                    <div className="mb-3">
                      <label htmlFor="paymentReceipt" className="form-label">
                        Comprobante (Captura de Pantalla del Pago)
                      </label>
                      <input
                        type="file"
                        id="paymentReceipt"
                        className="form-control"
                        accept="image/*"
                        onChange={handleReceiptChange}
                        required
                      />
                    </div>
                  )}
                  {/* Sender details conditional on origin method */}
                  {metodo === 'Banesco Panama' && (
                    <>
                      <hr />
                      <h6>Datos del Titular</h6>
                      <div className="mb-3">
                        <label htmlFor="senderFullName" className="form-label">Nombre del Titular</label>
                        <input type="text" id="senderFullName" className="form-control" value={senderFullName} onChange={(e) => setSenderFullName(e.target.value)} required />
                      </div>
                    </>
                  )}
                  {(metodo === 'Zelle' || metodo === 'Paypal') && (
                    <>
                      <hr />
                      <h6>Datos del Titular que Envía</h6>
                      <div className="row">
                        <div className="mb-3 col-md-6">
                          <label htmlFor="senderFirstName" className="form-label">Nombre</label>
                          <input type="text" id="senderFirstName" className="form-control" value={senderFirstName} onChange={(e) => setSenderFirstName(e.target.value)} required />
                        </div>
                        <div className="mb-3 col-md-6">
                          <label htmlFor="senderLastName1" className="form-label">Apellido</label>
                          <input type="text" id="senderLastName1" className="form-control" value={senderLastName1} onChange={(e) => setSenderLastName1(e.target.value)} required />
                        </div>
                      </div>
                    </>
                  )}
                  {/* no sender fields for Transferencia Bs, only receipt */}
                  <hr />
                  <h6>Datos de la Cuenta que Recibe</h6>
                  {/* Zelle y PayPal: nombre, apellido y email */}
                  {(destinoMetodo === 'Zelle' || destinoMetodo === 'Paypal') && (
                    <div>
                      <div className="row">
                        <div className="mb-3 col-md-6">
                          <label htmlFor="receiverFirstName" className="form-label">Nombre</label>
                          <input type="text" id="receiverFirstName" className="form-control" value={receiverFirstName} onChange={e => setReceiverFirstName(e.target.value)} required />
                        </div>
                        <div className="mb-3 col-md-6">
                          <label htmlFor="receiverLastName" className="form-label">Apellido</label>
                          <input type="text" id="receiverLastName" className="form-control" value={receiverLastName} onChange={e => setReceiverLastName(e.target.value)} required />
                        </div>
                      </div>
                      <div className="mb-3">
                        <label htmlFor="receiverEmail" className="form-label">Correo</label>
                        <input type="email" id="receiverEmail" className="form-control" value={receiverEmail} onChange={e => setReceiverEmail(e.target.value)} required />
                      </div>
                    </div>
                  )}
                  {/* Transferencia Bancaria: nombre, apellido y número de cuenta */}
                  {destinoMetodo === 'Transferencia Bancaria' && (
                    <div className="row">
                      <div className="mb-3 col-md-6">
                        <label htmlFor="receiverFirstName" className="form-label">Nombre</label>
                        <input type="text" id="receiverFirstName" className="form-control" value={receiverFirstName} onChange={e => setReceiverFirstName(e.target.value)} required />
                      </div>
                      <div className="mb-3 col-md-6">
                        <label htmlFor="receiverLastName" className="form-label">Apellido</label>
                        <input type="text" id="receiverLastName" className="form-control" value={receiverLastName} onChange={e => setReceiverLastName(e.target.value)} required />
                      </div>
                      <div className="mb-3 col-md-12">
                        <label htmlFor="receiverAccountNumber" className="form-label">Número de Cuenta</label>
                        <input type="text" id="receiverAccountNumber" className="form-control" value={receiverAccountNumber} onChange={e => setReceiverAccountNumber(e.target.value)} required />
                      </div>
                    </div>
                  )}
                  {/* Pago Móvil: nombre, apellido, teléfono, banco y cédula */}
                  {destinoMetodo === 'Pago Móvil' && (
                    <div>
                      <div className="row">
                        <div className="mb-3 col-md-6">
                          <label htmlFor="receiverFirstName" className="form-label">Nombre</label>
                          <input type="text" id="receiverFirstName" className="form-control" value={receiverFirstName} onChange={e => setReceiverFirstName(e.target.value)} required />
                        </div>
                        <div className="mb-3 col-md-6">
                          <label htmlFor="receiverLastName" className="form-label">Apellido</label>
                          <input type="text" id="receiverLastName" className="form-control" value={receiverLastName} onChange={e => setReceiverLastName(e.target.value)} required />
                        </div>
                      </div>
                      <div className="mb-3">
                        <label htmlFor="receiverMobile" className="form-label">Teléfono</label>
                        <input type="text" id="receiverMobile" className="form-control" value={receiverMobile} onChange={e => setReceiverMobile(e.target.value)} required />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="receiverBank" className="form-label">Banco</label>
                        <input type="text" id="receiverBank" className="form-control" value={receiverBank} onChange={e => setReceiverBank(e.target.value)} required />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="receiverID" className="form-label">Cédula o Pasaporte</label>
                        <input type="text" id="receiverID" className="form-control" value={receiverID} onChange={e => setReceiverID(e.target.value)} required />
                      </div>
                    </div>
                  )}
                  {/* Efectivo: nombre, apellido, cédula y teléfono */}
                  {destinoMetodo === 'Efectivo' && (
                    <div>
                      <div className="row">
                        <div className="mb-3 col-md-6">
                          <label htmlFor="receiverFirstName" className="form-label">Nombre</label>
                          <input type="text" id="receiverFirstName" className="form-control" value={receiverFirstName} onChange={e => setReceiverFirstName(e.target.value)} required />
                        </div>
                        <div className="mb-3 col-md-6">
                          <label htmlFor="receiverLastName" className="form-label">Apellido</label>
                          <input type="text" id="receiverLastName" className="form-control" value={receiverLastName} onChange={e => setReceiverLastName(e.target.value)} required />
                        </div>
                      </div>
                      <div className="mb-3">
                        <label htmlFor="receiverID" className="form-label">Cédula o Pasaporte</label>
                        <input type="text" id="receiverID" className="form-control" value={receiverID} onChange={e => setReceiverID(e.target.value)} required />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="receiverMobile" className="form-label">Teléfono</label>
                        <input type="text" id="receiverMobile" className="form-control" value={receiverMobile} onChange={e => setReceiverMobile(e.target.value)} required />
                      </div>
                    </div>
                  )}
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setShowModal(false)}
                  >
                    Cerrar
                  </button>
                  <button type="submit" className="btn btn-primary">
                    Confirmar Pago
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Envios;
